<template>
    <div class="mask common-toast-wrapper" v-show="show_vip_rights">
      <div class="img-wrap">
        <img src="./static/noAuthority.png" class="raiseImg" @click="jump" />
        <img src='./static/close.png' class="close" @click="closeAlert"/>
      </div>
    </div>
</template>
<script>
export default {
  name: 'noRights',
  data() {
    return {};
  },
  computed: {
    show_vip_rights() {
      return this.$store.state.vip.show_vip_rights;
    },
  },
  methods: {
    closeAlert() {
      this.$store.commit('CLOSE_VIP_RIGHTS');
    },
    jump() {
      this.$router.push('/thunder/openvip?fromType=noRights');
      this.$store.commit('CLOSE_VIP_RIGHTS');
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: $z_index_important;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-wrap {
  img {
    width: 80vw;
  }
}
</style>
